import { Component, OnInit, Inject } from "@angular/core";
import { listPagesDB } from "src/app/shared/tables/list-pages";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-section-list",
  templateUrl: "./section-list.component.html",
  styleUrls: ["./section-list.component.scss"],
})
export class SectionListComponent implements OnInit {
  constructor(
    private http: HttpClient,
    @Inject("API_ENDPOINT") private api_endpoint: string
  ) {}

  public list_sections = [];
  message = null;
  class = null;

  ngOnInit() {
    this.http.get<any>(this.api_endpoint + "/sections/").subscribe(
      (data) => {
        this.list_sections = data.data;
        // console.log(this.list_sections);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      }
    );
  }

  delete(id) {
    // console.log(this.Form.value)
    if (confirm("Are you sure to delete ")) {
      this.http.delete<any>(this.api_endpoint + "/sections/" + id).subscribe(
        (res) => {
          if (res.Error) {
            this.message = res.Error;
            this.class = "btn btn-primary";
            return;
          } else {
            this.message = "Successfully Deleted";
            this.class = "btn btn-success";
            this.ngOnInit();
          }
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    }
  }
}
